var _ = require('../utils/lib.js');

var Popup = function (selectors, classes) {
  this.selectors = selectors;
  this.classes = classes;
  this.html = document.documentElement;
  this.giftOptions = document.querySelector(this.selectors.giftOptions);
  this._addEventListeners();
};

Popup.prototype.open = function () {
  this.html.classList.add(this.classes.giftOptionsOpen);
};

Popup.prototype.close = function () {
  this.html.classList.remove(this.classes.giftOptionsOpen);
};

Popup.prototype.toggle = function () {
  if (this.html.classList.contains(this.classes.giftOptionsOpen)) {
    this.close();
  } else {
    this.open();
  }
};

// Private
Popup.prototype._addEventListeners = function () {
  var _this = this;
  // close the gift options if customer clicks on modal background
  this.giftOptions.addEventListener('click', function (e) {
    var target = e.target || e.srcElement;
    if (target == _this.giftOptions) {
      _this.close();
    }
  });
};

module.exports = Popup;
